<button type="button" class="btn {{ customClass }}" (click)="actionSelected()">
  @if (icon != '') {
    <i [class]="icon"></i>
  }
  <span [class]="showSpinner ? 'mr-2' : ''"> {{ label }}</span>
  @if (showSpinner) {
    <i class="fa fa-cog fa-spin"></i>
  }
</button>
